"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var withCustomError_1 = __importDefault(require("../helpers/withCustomError"));
var isEmptyValue_1 = __importDefault(require("../helpers/isEmptyValue"));
var isIntegerValue = function (value) { return Number(value) % 1 === 0; };
var isInteger = function (value) {
    if (isEmptyValue_1.default(value) || isIntegerValue(value)) {
        return undefined;
    }
    return 'The value must be an integer.';
};
exports.default = withCustomError_1.default(isInteger);
//# sourceMappingURL=isInteger.js.map